import { Component, OnInit } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { AlertController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ChooseclientPage } from 'src/app/pages/chooseclient/chooseclient.page';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { LanguageService } from 'src/app/services/language.service';
import { LoaderService } from 'src/app/services/loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-client',
  templateUrl: './change-client.page.html',
  styleUrls: ['./change-client.page.scss'],
})

export class ChangeClientPage implements OnInit {
  clients;
  width=window.innerWidth;
  constructor(
    private loaderService:LoaderService,
    public platformSRV:PlatformService,
    public dataService:DataService,
    public modalController: ModalController,
    private alertController: AlertController,
    public translateService: TranslateService,
  ) { }

  ngOnInit() {
    this.dataService.getStoredData({key:environment.clientsKey}).then(value=>{
      if(value){
        this.clients=value.clients
      }
    })
  }
 async addClient(){
  
  const mobileModal = await this.modalController.create({
    component: ChooseclientPage,
    breakpoints: [0.5, 0.8,1],
    initialBreakpoint: 1,
    cssClass:"modal-mobile-normal",
    componentProps:{
      fromModal:true
    },
  })
  const tabletModal = await this.modalController.create({
    component: ChooseclientPage,
    breakpoints: [0.5, 0.8,1],
    initialBreakpoint: 1, 
    cssClass:"modal-tablet-normal",
    componentProps:{
      fromModal:true
    },
  })
  
  
  mobileModal.onDidDismiss().then(data=>{
    if(data.data=="refresh"){
      this.modalController.dismiss("refresh")
      this.dataService.resetDisclaimers()
    }
  })
  tabletModal.onDidDismiss().then(data=>{
    if(data.data=="refresh"){
      this.modalController.dismiss("refresh")
      this.dataService.resetDisclaimers()
    }
  })
  if(this.platformSRV.device=='mobile'){
    return await mobileModal.present();
  } else if(this.platformSRV.device=='tablet'){
    return await tabletModal.present();
  }
  }
  async closeModal(){
    this.modalController.dismiss()
  }
  async removeClient(client){
    var clientDisplay;
    if(this.dataService.isProductionBuild){
      clientDisplay=client.clientName
    } else {
      clientDisplay=client.webUrl
    }
    const alert = await this.alertController.create({
      header: this.translateService.instant('keys.data.common.remove') || 'Remove',
      message:clientDisplay  + '?',
      buttons: [
        {
          text: this.translateService.instant('keys.data.common.no') || 'No',
          role: 'cancel',
          handler: () => {
            
          },
        },
        {
          text: this.translateService.instant('keys.data.common.yes') || 'Yes',
          role: 'confirm',
          handler: () => {
            this.dataService.getStoredData({key:environment.clientsKey}).then(value=>{
              if(value){
               var newArray=value.clients
               for(var i=0;i<newArray.length;i++){
                if(newArray[i]?.url){ //cache backward compatibility
                  newArray[i]['webUrl']=newArray[i]?.url
                }
                if(newArray[i]['webUrl']==client.webUrl){
                 newArray.splice(i,1)
                } 
               }
              
                 
               this.dataService.storeData(environment.clientsKey,
                 {
                    clients:newArray
                  
                }).then(()=>{
                  this.dataService.apiUrl=client.webUrl
                  this.modalController.dismiss("refresh")
                  this.dataService.resetAppLanguage()
                })
              }})}
        },
      ],
    });

    await alert.present();
  }
  async changeClient(e,client){
    var clientDisplay;
    if(this.dataService.isProductionBuild){
      clientDisplay=client.clientName
    } else {
      clientDisplay=client.webUrl
    }
    if(e.detail.checked){
      const alert = await this.alertController.create({
        header: this.translateService.instant('keys.data.config.change_provider_to') ,
        message:clientDisplay + '?',
        buttons: [
          {
            text: this.translateService.instant('keys.data.common.no') || 'No',
            role: 'cancel',
            handler: () => {
              e.target.checked=false
            },
          },
          {
            text: this.translateService.instant('keys.data.common.yes') || 'Yes',
            role: 'confirm',
            handler: () => {
              this.dataService.getStoredData({key:environment.clientsKey}).then(value=>{
                if(value){
                 var newArray=value.clients
                 
                 
                 newArray.forEach(element => {
                  if(element?.url){ //cache backward compatibility
                    element['webUrl'] = element?.url
                  }
                  if(element['webUrl']==client.webUrl){
                    element['lastSelected']=true
                  } else {
                    element['lastSelected']=false
                  }
                 });
                   
                 this.dataService.storeData(environment.clientsKey,
                   {
                      clients:newArray
                   
                  }).then(()=>{
                     
                      this.dataService.resetDisclaimers()
                        this.dataService.apiUrl=client.webUrl
                        this.dataService.settings={}
                       this.dataService.getDisclaimers()
      this.dataService.getStoredData({key:environment.clientsKey}).then(value=>{
        if(value){
          for (
            var i = 0;
            i < value.clients.length;
            i++
          ){
            if(value.clients[i].lastSelected==true){
              this.dataService.selectedClient=value.clients[i]
             
              
            }
          }
        }
      })
      
      this.modalController.dismiss("refresh")
      this.dataService.resetAppLanguage()
      
                        
                    
                   
                    
                  })
              
                
              }})}
          },
        ],
      });
  
      await alert.present();
    }
    
    
  }

}
